/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./footer.styles.css";
import Logo from "../../assets/images/logo.png";
import facebook from "../../assets/icons/facebook.png";
import twitter from "../../assets/icons/twitter.png";
import instagram from "../../assets/icons/instagram.png";

export default function Footer() {
  return (
    <>
      <section id="footer">
        <div className="text-center text-md-start">
          <div className="row">
            <div className="col-md-3 flexit">
              <img className="footerLogo" src={Logo} alt="Logo" />
            </div>
            <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4 footerSubHeader">
                Software Services
              </h6>
              <p>
                <a href="#!" className="text-reset footerSubText">
                  Angular
                </a>
              </p>
              <p>
                <a href="#!" className="text-reset footerSubText">
                  React
                </a>
              </p>
              <p>
                <a href="#!" className="text-reset footerSubText">
                  Vue
                </a>
              </p>
              <p>
                <a href="#!" className="text-reset footerSubText">
                  Laravel
                </a>
              </p>
            </div>

            <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4 footerSubHeader">
                Useful links
              </h6>
              <p>
                <a href="#!" className="text-reset footerSubText">
                  Pricing
                </a>
              </p>
              <p>
                <a href="#!" className="text-reset footerSubText">
                  Settings
                </a>
              </p>
              <p>
                <a href="#!" className="text-reset footerSubText">
                  Orders
                </a>
              </p>
              <p>
                <a href="#!" className="text-reset footerSubText">
                  Help
                </a>
              </p>
            </div>
            <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4 footerSubHeader">
                Contact
              </h6>
              <p className="footerSubText">
                New York, NY 10012, US 
              </p>
              <p className="footerSubText">
                info@example.com
              </p>
              <p className="footerSubText">
                +01 234 567 88
              </p>
              <p className="footerSubText">
                +01 234 567 89
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="footer-bar">
        <div className="copyright flexit pad-50">
          © 2021 Copyright :
          &nbsp; {/* To add space after the colon*/}
            <a className="text-reset fw-bold" href="https://mdbootstrap.com/">
            Istellar
          </a>
        </div>
          <div className="social-media-icons pad-50">
            <a href="" className="text-reset">
              <img src={facebook} alt="facebook" />
            </a>
            <a href="" className="text-reset">
              <img src={twitter} alt="twitter" />
            </a>
            <a href="" className="text-reset">
              <img src={instagram} alt="instagram" />
            </a>
          </div>
      </div>
    </>
  );
}
